import { render, staticRenderFns } from "./TheConstructions.vue?vue&type=template&id=5a2e5b22&"
import script from "./TheConstructions.vue?vue&type=script&lang=js&"
export * from "./TheConstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports